
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 4H2v12h16V4zM2 3a1 1 0 00-1 1v12a1 1 0 001 1h16a1 1 0 001-1V4a1 1 0 00-1-1H2zm4.818 5.5a.5.5 0 01.394.192l3.513 4.504 2.788-2.145a.5.5 0 01.618.006l3.182 2.553a.5.5 0 11-.626.78l-2.875-2.307-2.87 2.208a.5.5 0 01-.7-.088l-3.424-4.39-3.424 4.39a.5.5 0 11-.788-.615l3.818-4.896a.5.5 0 01.394-.192zM11.5 8a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM13 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z","fill":"#303133"}})])
          )
        }
      }
    